import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import VehicleDetail from "@/pages/VehicleDetail";
import Repairs from "@/pages/Repairs";
import Auctions from "@/pages/Auctions";
import Expenses from "@/pages/Expenses";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import { SalesList, SaleDetail } from "@/pages/Sales";
import Reports from "@/pages/Reports";
import AuditLog from "@/pages/AuditLog";
import Users from "@/pages/Users";
import ChangePassword from "@/pages/ChangePassword";
import Insights from "@/pages/Insights";
import ImportWizard from "@/pages/ImportWizard";
import DealSheet from "@/pages/DealSheet";
import BusinessSummary from "@/pages/BusinessSummary";

// Stable role arrays to avoid new-array-on-every-render
const ADMIN_ONLY = ["admin"];
const ADMIN_ACCOUNTANT = ["admin", "accountant"];

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/inventory/:id" element={<VehicleDetail />} />
              <Route path="/deal-sheet/:id" element={<DealSheet />} />
              <Route path="/insights" element={<ProtectedRoute roles={ADMIN_ACCOUNTANT}><Insights /></ProtectedRoute>} />
              <Route path="/business-summary" element={<BusinessSummary />} />
              <Route path="/import" element={<ProtectedRoute roles={ADMIN_ONLY}><ImportWizard /></ProtectedRoute>} />
              <Route path="/repairs" element={<Repairs />} />
              <Route path="/auctions" element={<Auctions />} />
              <Route path="/expenses" element={<ProtectedRoute roles={ADMIN_ACCOUNTANT}><Expenses /></ProtectedRoute>} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/customers/:id" element={<CustomerDetail />} />
              <Route path="/sales" element={<SalesList />} />
              <Route path="/sales/:id" element={<SaleDetail />} />
              <Route path="/reports" element={<ProtectedRoute roles={ADMIN_ACCOUNTANT}><Reports /></ProtectedRoute>} />
              <Route path="/audit" element={<ProtectedRoute roles={ADMIN_ACCOUNTANT}><AuditLog /></ProtectedRoute>} />
              <Route path="/users" element={<ProtectedRoute roles={ADMIN_ONLY}><Users /></ProtectedRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
